import { selector } from 'recoil';

import { collections, constants } from 'lib/constants';
import { marketplaceFiltersState, productsState } from '../atoms';

export const filteredProductsState = selector({
	key: 'filteredProductsState',
	get: ({ get }) => {
		let products = get(productsState);
		const marketplaceFilters = get(marketplaceFiltersState);

		let filteredProducts = [...products];

		const collection = collections.find(collection => collection.key === marketplaceFilters.collection);
		if (collection) {
			filteredProducts = filteredProducts.filter(product => product.collectionId === collection.id);
		}

		// Keep count of the filtered down products
		// This will be used to show a correct number of pages in the pagination
		const count = filteredProducts.length;

		if (marketplaceFilters.sort) {
			filteredProducts = filteredProducts.sort((a, b) => {
				if (marketplaceFilters.sort === 'priceAsc') {
					if (a.price > b.price) {
						return 1;
					} else {
						return -1;
					}
				}

				if (marketplaceFilters.sort === 'priceDesc') {
					if (a.price < b.price) {
						return 1;
					} else {
						return -1;
					}
				}

				return 0;
			});
		}

		// Return only 8 products. If less than 8 then return remaining products
		filteredProducts = filteredProducts.slice(
			(marketplaceFilters.pagination - 1) * constants.PAGE_SIZE,
			marketplaceFilters.pagination * constants.PAGE_SIZE
		);

		return {
			products: filteredProducts,
			count
		};
	}
});
